import { Box } from "@mui/material";
import { getArrivalTimeDescriptionLines } from "@src/appV2/redesign/ArrivalTime/getArrivalTimeDescriptionLines";

import { BookabilityCriteriaCardDescriptionText } from "../BookabilityCriteriaCardDescriptionText";

interface ShiftBottomSheetArrivalTimeDescriptionProps {
  startDatetime: Date;
  workplaceTimezone: string;
}

export function ShiftBottomSheetArrivalTimeDescription(
  props: ShiftBottomSheetArrivalTimeDescriptionProps
) {
  const { startDatetime, workplaceTimezone } = props;

  const descriptionLines = getArrivalTimeDescriptionLines(startDatetime, workplaceTimezone);

  return (
    <Box>
      {descriptionLines.map((line) => (
        <BookabilityCriteriaCardDescriptionText key={line}>
          {line}
        </BookabilityCriteriaCardDescriptionText>
      ))}
    </Box>
  );
}
